export { TCSRelationshipType } from './generated/TCSRelationshipType.js';